angular.module('app').component('traceSummaryModal', {
    bindings: {
        resolve: '<', // params: ITraceSummaryModalParams
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    controller: function ($window, $uibModal) {
        let vm = this;
        $window.vm = vm;
        this.$onInit = function () {
            vm.testerId = -1;
            vm.simId = -1;
            vm.suiteId = -1;
        };
        this.$onChanges = function (changes) {
            if (!changes.resolve) {
                return;
            }
            let params = this.resolve.params;
        };
        vm.close = close;
        function close() {
            $uibModal.dismiss('close');
        }
    },
    template: `
<!--
    <div class="modal-header">
<div class="modal-title h4">Trace Summary</div>
</div>
-->
<div class="trace-summary-modal-body">

<trace-summary
tester-id="vm.testerId"
sim-id="vm.,simId"
suite-id="vm.suite-id">
</trace-summary>

</div>
<!--
<div class="modal-footer">
    Hello
</div>
-->
`
});
